__turbopack_context__.v({
  "counterLabel": "landing-module__zUj6Jq__counterLabel",
  "counterNum": "landing-module__zUj6Jq__counterNum",
  "eyebrow": "landing-module__zUj6Jq__eyebrow",
  "eyebrowDots": "landing-module__zUj6Jq__eyebrowDots",
  "faqAnswer": "landing-module__zUj6Jq__faqAnswer",
  "faqCard": "landing-module__zUj6Jq__faqCard",
  "faqQuestion": "landing-module__zUj6Jq__faqQuestion",
  "folio": "landing-module__zUj6Jq__folio",
  "folioLabel": "landing-module__zUj6Jq__folioLabel",
  "folioSub": "landing-module__zUj6Jq__folioSub",
  "folioTitle": "landing-module__zUj6Jq__folioTitle",
  "hero": "landing-module__zUj6Jq__hero",
  "heroAccent": "landing-module__zUj6Jq__heroAccent",
  "heroIntro": "landing-module__zUj6Jq__heroIntro",
  "heroSample": "landing-module__zUj6Jq__heroSample",
  "heroSubtitle": "landing-module__zUj6Jq__heroSubtitle",
  "heroTitle": "landing-module__zUj6Jq__heroTitle",
  "rail": "landing-module__zUj6Jq__rail",
  "railSeg": "landing-module__zUj6Jq__railSeg",
  "reviewCard": "landing-module__zUj6Jq__reviewCard",
  "reviewMeta": "landing-module__zUj6Jq__reviewMeta",
  "reviewQuote": "landing-module__zUj6Jq__reviewQuote",
  "reviewStars": "landing-module__zUj6Jq__reviewStars",
  "scanCard": "landing-module__zUj6Jq__scanCard",
  "scanCardTitle": "landing-module__zUj6Jq__scanCardTitle",
  "scanPreviewArrow": "landing-module__zUj6Jq__scanPreviewArrow",
  "scanPreviewCaption": "landing-module__zUj6Jq__scanPreviewCaption",
  "scanPreviewStrip": "landing-module__zUj6Jq__scanPreviewStrip",
  "shotCard": "landing-module__zUj6Jq__shotCard",
  "shotCardInner": "landing-module__zUj6Jq__shotCardInner",
  "shotLabel": "landing-module__zUj6Jq__shotLabel",
  "uploadAction": "landing-module__zUj6Jq__uploadAction",
});
